import SectionWrapper from "../../../components/layout/SectionWrapper";
import styled from "../../../util/styled";

const PREFIX = "Hero";

export const classes = {
  root: `${PREFIX}-root`,
  background: `${PREFIX}-background`,
  typo: `${PREFIX}-typo`,
  actions: `${PREFIX}-actions`,
  xsActions: `${PREFIX}-xsActions`,
  button: `${PREFIX}-button`,
};

export const StyledSectionWrapper = styled(SectionWrapper)<{
  isMobile: boolean;
}>(({ theme, isMobile }) => ({
  height: 520,

  [`& .${classes.background}`]: {
    backgroundImage: !isMobile
      ? "url('/images/innovance-solutions-hero-illustration.svg')"
      : "none",
    backgroundPosition: "95%",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundClip: "padding-box",
    backgroundAttachment: "local",
    display: "flex",
    alignItems: "center",
    height: "100%",
  },

  [`& .${classes.typo}`]: {
    color: theme.palette.common.white,
  },

  [`& .${classes.actions}`]: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2, 0),
  },

  [`& .${classes.xsActions}`]: {
    flexDirection: "column",
  },

  [`& .${classes.button}`]: {
    margin: theme.spacing(),
    padding: theme.spacing(1, 2),
    "&:first-of-type": {
      backgroundColor: theme.palette.innoBlue.main,
      color: theme.palette.innoBlue.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.innoBlue.light,
        color: theme.palette.innoBlue.dark,
      },
    },
    "&:last-child": {
      backgroundColor: theme.palette.innoGrey.main,
      color: theme.palette.innoGrey.contrastText,
      "&:hover": {
        backgroundColor: theme.palette.innoGrey.light,
        color: theme.palette.innoGrey.dark,
      },
    },
  },
}));
